import * as React from 'react';
import { ICommand } from '../../../models/commands/ICommand';
import { Facet } from '../../../models/Facet';
import { ClearSelectionAction } from '../../actions/clearSelection/ClearSelectionAction';
import { ShowOnlyWithSelection } from '../../selectionVisibility/SelectionVisibility';
import { ICommandBarItemProps } from 'office-ui-fabric-react/lib/CommandBar';
import { ICommandBarItemRenderProps, commandBarItemDefaultRender } from '../commandBarItemDefaultRender';
import { withSelectedItems } from '../../decorators/selectors';
import ClearSelectionCommandStrings from './ClearSelectionCommand.resx';
import { formatWithLocalizedCountValue } from '@ms/utilities-strings/lib/index';
import { IComponentAsProps } from '@uifabric/utilities/lib/IComponentAs';

type IItemClearSelectionCommandButtonProps = IComponentAsProps<ICommandBarItemRenderProps> & {
  item: ICommandBarItemProps;
  itemKeys: string[];
};

class ItemClearSelectionCommandButton extends React.PureComponent<IItemClearSelectionCommandButtonProps> {
  public render(): JSX.Element | null {
    const {
      defaultRender: DefaultRender,
      itemKeys,
      item,
      ...buttonProps
    } = this.props;

    return DefaultRender ? (
      <DefaultRender
        { ...buttonProps }
        item={
          {
            ...item,
            name: formatWithLocalizedCountValue(
              ClearSelectionCommandStrings.ClearSelectionCommandText,
              ClearSelectionCommandStrings.ClearSelectionCommandTextIntervals,
              itemKeys.length),
            ariaLabel: formatWithLocalizedCountValue(
              ClearSelectionCommandStrings.ClearSelectionCommandAriaLabel,
              ClearSelectionCommandStrings.ClearSelectionCommandAriaLabelIntervals,
              itemKeys.length)
          }
        }
      />
    ) : null;
  }
}

const ClearSelectionCommandButton = withSelectedItems()(ItemClearSelectionCommandButton);

export const clearSelectionCommand: ICommand = {
  key: new Facet('clearSelectionCommand').id,
  iconProps: {
    iconName: 'Clear'
  },
  keytipProps: {
    content: ClearSelectionCommandStrings.ClearSelectionShortcutDesc,
    keySequences: ['CtrlD']
  },
  action: <ShowOnlyWithSelection><ClearSelectionAction /></ShowOnlyWithSelection>,
  onRender: (item: ICommandBarItemProps): JSX.Element => {
    return (
      <ClearSelectionCommandButton
        item={ item }
        defaultRender={ commandBarItemDefaultRender }
      />
    );
  }
};
